/**
 *
 */
var BoundsType = (function () {
    function BoundsType() {
    }
    return BoundsType;
}());
export { BoundsType };
/**
 *
 */
BoundsType.SPHERE = "sphere";
/**
 *
 */
BoundsType.AXIS_ALIGNED_BOX = "axisAlignedBox";
/**
 *
 */
BoundsType.NULL = "null";



// WEBPACK FOOTER //
// ../dist/lib/bounds/BoundsType.js